import _Input from './Input'
import _InputConnected from './Input.container'

export const Input = _Input
export const InputConnected = _InputConnected



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/components/Input/Input/index.js